const CHECK_SESSION_REQUEST = 'support/auth/CHECK_SESSION_REQUEST';
const CHECK_SESSION_SUCCESS = 'support/auth/CHECK_SESSION_SUCCESS';
const CHECK_SESSION_FAILURE = 'support/auth/CHECK_SESSION_FAILURE';
const LOGOUT = 'support/auth/LOGOUT';

const initialState = {
  isAuthenticated: false,
  isLoading: true,
  roles: [],
  username: null,
};

export const actions = {
  checkSession: () => ({ type: CHECK_SESSION_REQUEST }),
  checkSessionSuccess: (payload) => ({ type: CHECK_SESSION_SUCCESS, payload }),
  checkSessionFailure: (error) => ({ type: CHECK_SESSION_FAILURE, error }),
  logout: () => ({ type: LOGOUT }),
};

export const types = {
  CHECK_SESSION_REQUEST,
  CHECK_SESSION_SUCCESS,
  CHECK_SESSION_FAILURE,
  LOGOUT,
};

export function authReducer(state = initialState, action) {
  switch (action.type) {
    case CHECK_SESSION_REQUEST:
      return { ...state, isLoading: true };
    case CHECK_SESSION_SUCCESS:
      if (action.payload && action.payload.authenticated) {
        return {
          isAuthenticated: true,
          isLoading: false,
          roles: action.payload.roles || [],
          username: action.payload.username || null,
        };
      }
      return { ...initialState, isLoading: false };
    case CHECK_SESSION_FAILURE:
      return { ...initialState, isLoading: false };
    case LOGOUT:
      return { ...initialState, isLoading: false };
    default:
      return state;
  }
}
